export default {
    title: "Detalle de RIPS",
    subtitle: "| Tipo Factura/Nota:",
    payerNit: "Nit de pagador",
    payerName: "Nombre pagador",
    grossValue: "Valor bruto",
    invoiceNumber: "Número Factura:",
    noteType: "Tipo de Nota:",
    paymentMode: "Modalidad de pago:",
    benefitPlan: "Plan de beneficios",
    contract: "Contrato",
    policy: "Póliza",
    billingPeriodStart: "Inicio periodo Facturación",
    billingPeriodEnd: "Fin periodo Facturación",
    electronicInvoiceUniqueCode: "CUFE",
    users: "Pacientes",
    services: {
        consultations: "Consultas",
        procedures: "Procedimientos",
        emergencies: "Urgencias",
        hospitalization: "Hospitalización",
        neonates: "Recién Nacido",
        drugs: "Medicamentos",
        otherServices: "Otros Servicios"
    },
    user: {
        identificationTypeCode: "Documento de identificación",
        identificationNumber: "Número de identificación",
        userType: "Tipo de usuario",
        birthDate: "Fecha de Nacimiento",
        sex: "Sexo",
        countryCode: "País de residencia",
        cityCode: "Municipio",
        zoneCode: "Zona territorial",
        hasMedicalIncapacity: "Incapacidad",
        registrySiras: "Código SIRAS",
        sequenceId: "Consecutivo",
        nativeCountryCode: "País de origen",
        userTotalAmount: "Valor de cuenta"
    },
    identificator: 'ID',
    totalValue: 'Total:',
    serviceDetails: {
        providerCode: "Prestador",
        attentionStartAt: "Inicio de atención",
        authorizationNumber: "Autorización",
        consultationCode: "Consulta",
        attentionMode: "Modalidad",
        serviceGroupCode: "Grupo de servicios",
        serviceCode: "Servicio",
        purposeCode: "Finalidad",
        attentionCauseCode: "Causa de atención",
        principalDiagnosisCode: "Diagnóstico principal",
        firstRelatedDiagnosisCode: "Diagnóstico relacionado 1",
        secondRelatedDiagnosisCode: "Diagnóstico relacionado 2",
        thirdRelatedDiagnosisCode: "Diagnóstico relacionado 3",
        principalDiagnosisTypeCode: "Tipo diagnóstico ppal",
        identificationTypeCode: "Tipo id. del médico",
        identificationNumber: "Identificación del médico",
        serviceValue: "Valor servicio",
        revenueConceptCode: "Concepto recaudo",
        moderatorPaymentValue: "Pago moderador",
        invoiceNumber: "FEV Pago Moderador",
        sequenceId: "Consecutivo",
        mipresIdentifier: "Id Mipres",
        procedureCode: "Procedimiento",
        serviceEntryMode: "Via de ingreso",
        relatedDiagnosisCode: "Diagnóstico relacionado",
        complicationDiagnosisCode: "Diagnóstico complicación",
        dischargeConditionAndDestinationCode: "Destino usuario al egreso",
        demiseCauseDiagnosisCode: "Diagnóstico de muerte",
        dischargedAt: "Fecha de egreso",
        gestationalAge: "Edad gestacional",
        prenatalConsultationCount: "Número consultas cuidado prenatales",
        biologicalSex: "Sexo",
        currentWeight: "Peso",
        drugType: "Tipo medicamento",
        drugCode: "Tecnología en salud",
        genericName: "Nombre tecnología en salud",
        dosageStrength: "Concentración",
        unitOfMeasure: "Unidad de medida",
        dosageForm: "Forma farmacéutica",
        minimumUnitDispensed: "Unidad dispensación",
        drugAmount: "Cantidad",
        treatmentDays: "Días de tratamiento",
        otherServiceType: "Tipo otros servicios",
        otherServiceCode: "Tecnología en salud",
        otherServiceName: "Nombre Tecnología en Salud",
        otherServiceAmount: "Cantidad",
        otherServiceUnitCost: "Valor unitario",
        drugUnitCost: "Valor Unitario",
        principalAdmissionDiagnosisCode: "Diagnóstico de ingreso",
        principalDischargeDiagnosisCode: "Diagnóstico de egreso",
        firstRelatedDischargeDiagnosisCode: "Diagnóstico relacionado 1",
        secondRelatedDischargeDiagnosisCode: "Diagnóstico relacionado 2",
        thirdRelatedDischargeDiagnosisCode: "Diagnóstico relacionado 3",
        dispensationAt: "Fecha de dispensación",
        birthDate: "Fecha de nacimiento",
        neonates: {
            identificationTypeCode: "Tipo de identificación",
            identificationNumber: "Identificación"
        },
        vidaCode: "Código VIDA",
        cie11Action: "Ver diagnósticos CIE-11"
    },
    status: 'ESTADO: ',
    cie11Dialog: {
        title: "Diagnósticos CIE-11",
        empty: "No hay diagnósticos CIE-11 registrados para este detalle.",
        notRegistered: "No registrado",
        columns: {
            type: "Tipo de diagnóstico",
            code: "Código",
            name: "Nombre"
        },
        types: {
            principal: "Principal",
            principalDischarge: "Principal Egreso",
            related: "Relacionado",
            related1: "Relacionado 1",
            related2: "Relacionado 2",
            related3: "Relacionado 3",
            relatedDischarge1: "Relacionado Egreso 1",
            relatedDischarge2: "Relacionado Egreso 2",
            relatedDischarge3: "Relacionado Egreso 3",
            complication: "Complicación",
            demiseCause: "Muerte"
        }
    }
}